import _ from 'lodash';
import * as types from '../mutation-types';
import monitoramentoApi from '../../api/monitoramento';
import { addHighlightConteudoAparicao } from "../../utils/string";

// initial state
const state = {
  all: {
    items: [],
    paginator: {},
    changed: true,
  },
  monitoramento: {
    items: [],
    paginator: {},
    changed: true,
    id: null,
  },
  favoritos: {
    items: [],
    paginator: {},
    changed: true,
  },
  aparicao: {
    item: {},
  },
};

// getters
const getters = {
  aparicao: (state) => state.aparicao.item
};

// actions
const actions = {
  getAparicao({ commit }, { forceReload, ...payload }) {
    if (typeof payload.aparicao !== 'undefined' && payload.aparicao.visualizado === 'NAO') {
      const pastaId = payload.aparicao.pasta ? payload.aparicao.pasta.id : undefined;
      commit(types.VISUALIZAR_APARICOES, payload.id);
      commit(types.ATUALIZAR_NOTIFICACOES_NAO_VISUALIZADAS, {
        pastaId,
        monitoramentoId: payload.aparicao.monitoramento_id,
        incrementar: false,
      });
    }
    if ((forceReload === true) || (state.aparicao.item.id !== payload.id || (payload.page && payload.page !== state.aparicao.item.objeto.paginas.paginator.current_page))) {
      return monitoramentoApi.getAparicao(payload)
        .then(({ data }) => {
          commit(types.SET_APARICAO, data);
          commit(types.ADD_HIGHLIGHT_APARICAO);
        });
    }
    return Promise.resolve(true);
  },
  getAparicoes({ commit }, { id, monitoramento, nextPage, isTribunal, force }) {
    if (typeof monitoramento !== 'undefined' && !isTribunal) {
      commit(types.SET_MONITORAMENTO, monitoramento);
    }

    if (typeof nextPage !== 'undefined' && typeof state.monitoramento.paginator !== 'undefined') {
      const page = state.monitoramento.paginator.current_page + 1;
      return monitoramentoApi.getAparicoes({ id, page })
        .then(({ data }) => {
          commit(types.PUSH_APARICOES_MONITORAMENTO, { data, id });
        });
    }
    if (parseInt(state.monitoramento.id) !== parseInt(id)) {
      // Limpamos as aparições no monitoramento antigo
      commit(types.SET_APARICOES_MONITORAMENTO, { data: { items: [], paginator: {} }, id });
      return monitoramentoApi.getAparicoes({ id })
        .then(({ data }) => {
          // Adicionamos as aparições do monitoramento atual
          commit(types.SET_APARICOES_MONITORAMENTO, { data, id });
        });
    }
    if (force) {
      return monitoramentoApi.getAparicoes({ id })
        .then(({ data }) => {
          // Adicionamos as aparições do monitoramento atual
          commit(types.SET_APARICOES_MONITORAMENTO, { data, id, concat: true });
        });
    }
    return Promise.resolve(true);
  },
  getAparicoesFavoritas({ commit }, { nextPage }) {
    let page = null;
    if (nextPage) {
      page = state.favoritos.paginator.current_page + 1;
      return monitoramentoApi.getAparicoesFavoritas(page, (data) => {
        commit(types.PUSH_APARICOES_FAVORITAS, data);
      });
    }
    if (state.favoritos.changed) {
      return monitoramentoApi.getAparicoesFavoritas(page, (data) => {
        commit(types.SET_APARICOES_FAVORITAS, data);
      });
    }
    return Promise.resolve(true);
  },
  favoritarAparicoes({ commit }, aparicoes) {
    commit(types.FAVORITAR_APARICOES, aparicoes);
    monitoramentoApi.favoritarAparicoes(aparicoes);
  },
  desfavoritarAparicoes({ commit }, aparicaoId) {
    commit(types.DESFAVORITAR_APARICOES, aparicaoId);
    monitoramentoApi.desfavoritarAparicoes(aparicaoId);
  },
  visualizarAparicoes({ commit }, aparicao) {
    if (typeof aparicao !== 'undefined') {
      const pastaId = aparicao.pasta ? aparicao.pasta.id : undefined;
      commit(types.ATUALIZAR_NOTIFICACOES_NAO_VISUALIZADAS, {
        pastaId,
        monitoramentoId: aparicao.monitoramento_id,
        incrementar: false,
      });
    }
    commit(types.VISUALIZAR_APARICOES, aparicao.id);
    monitoramentoApi.visualizarAparicoes(aparicao.id);
  },
  marcarNaoVisualizadaAparicoes({ commit }, aparicao) {
    if (typeof aparicao !== 'undefined') {
      const pastaId = aparicao.pasta ? aparicao.pasta.id : undefined;
      commit(types.ATUALIZAR_NOTIFICACOES_NAO_VISUALIZADAS, {
        pastaId,
        monitoramentoId: aparicao.monitoramento_id,
        incrementar: true,
      });
    }
    commit(types.MARCAR_NAO_VISUALIZADA_APARICOES, aparicao.id);
    commit(types.SET_ITENS_SELECIONADO, []);
    monitoramentoApi.marcarNaoVisualizadaAparicoes(aparicao.id);
  },
  excluirAparicoes({ commit }, aparicoes) {
    commit(types.EXCLUIR_APARICOES, aparicoes);
    commit(types.SET_ITENS_SELECIONADO, []);
    return monitoramentoApi.excluirAparicoes(aparicoes);
  },
  mudarPaginaDiario({ commit }, payload) {
    if (state.aparicao.item.objeto.id !== payload.id || (payload.page && payload.page !== state.aparicao.item.objeto.paginas.paginator.current_page)) {
      return monitoramentoApi.getDiario(payload)
          .then(({ data }) => {
            commit(types.MUDAR_PAGINA_DIARIO, data);
          });
    }
    return Promise.resolve(true);
  },
};

// mutations
const mutations = {
  [types.SET_APARICOES](state, { items, paginator }) {
    state.all.changed = false;
    state.all.paginator = paginator;
    state.all.items = items;
  },
  [types.SET_APARICOES_FAVORITAS](state, payload) {
    state.favoritos.changed = false;
    state.favoritos.items = payload.items;
    state.favoritos.paginator = payload.paginator;
  },
  [types.SET_APARICOES_MONITORAMENTO](state, { data, id, concat = false }) {
    state.monitoramento.changed = false;
    state.monitoramento.id = id;
    if (concat) {
      state.monitoramento.items = _.uniqBy(state.monitoramento.items.concat(data.items), a => a.id);
    } else {
      state.monitoramento.items = data.items;
    }
    state.monitoramento.paginator = data.paginator;
  },
  [types.PUSH_APARICOES_MONITORAMENTO](state, { data }) {
    state.monitoramento.items = state.monitoramento.items.concat(data.items);
    state.monitoramento.paginator = data.paginator;
  },
  [types.PUSH_APARICOES_FAVORITAS](state, payload) {
    state.favoritos.items = state.favoritos.items.concat(payload.items);
    state.favoritos.paginator = payload.paginator;
  },
  [types.PUSH_APARICOES](state, payload) {
    state.all.items = state.all.items.concat(payload.items);
    state.all.paginator = payload.paginator;
  },
  [types.SET_APARICAO](state, aparicao) {
    state.aparicao.item = aparicao;
  },
  [types.ADD_HIGHLIGHT_APARICAO](state) {
    let conteudo = '';
    if (typeof state.aparicao.item.objeto.paginas !== 'undefined') {
      conteudo = state.aparicao.item.objeto.paginas.items.conteudo;
    } else if (typeof state.aparicao.item.objeto.conteudo !== 'undefined') {
      conteudo = state.aparicao.item.objeto.conteudo;
    }
    if (conteudo.length < 80000) {
      if (typeof state.aparicao.item.objeto.paginas !== 'undefined') {
        state.aparicao.item.objeto.paginas.items.conteudo = addHighlightConteudoAparicao(
          state.aparicao.item.monitoramento_termo,
          state.aparicao.item.monitoramento_variacoes,
          conteudo
        );
      } else if (typeof state.aparicao.item.objeto.conteudo !== 'undefined') {
        state.aparicao.item.objeto.conteudo = addHighlightConteudoAparicao(
          state.aparicao.item.monitoramento_termo,
          state.aparicao.item.monitoramento_variacoes,
          conteudo
        );
      }
    }
  },
  [types.EXCLUIR_APARICOES](state, aparicoes) {
    state.all.items = state.all.items.filter(a => aparicoes.indexOf(a.id) === -1);
    state.monitoramento.items = state.monitoramento.items.filter(a => aparicoes.indexOf(a.id) === -1);
    state.favoritos.items = state.favoritos.items.filter(a => aparicoes.indexOf(a.id) === -1);
  },
  [types.FAVORITAR_APARICOES](state, aparicoes) {
    let item = state.all.items.find(a => a.id === aparicoes);
    if (item) item.favorito = 'SIM';
    item = state.favoritos.items.find(a => a.id === aparicoes);
    if (item) item.favorito = 'SIM';
    item = state.monitoramento.items.find(a => a.id === aparicoes);
    if (item) item.favorito = 'SIM';
    state.favoritos.changed = true;
  },
  [types.DESFAVORITAR_APARICOES](state, aparicaoId) {
    let item = state.all.items.find(a => a.id === aparicaoId);
    if (item) item.favorito = 'NAO';
    item = state.favoritos.items.find(a => a.id === aparicaoId);
    if (item) item.favorito = 'NAO';
    item = state.monitoramento.items.find(a => a.id === aparicaoId);
    if (item) item.favorito = 'NAO';
    state.favoritos.changed = true;
  },
  [types.VISUALIZAR_APARICOES](state, aparicaoId) {

    let item = state.all.items.find(a => a.id === aparicaoId);
    if (item && !item.bloqueado) {
      item.visualizado = 'SIM';
    }

    item = state.favoritos.items.find(a => a.id === aparicaoId);
    if (item && !item.bloqueado) {
      item.visualizado = 'SIM';
    }

    item = state.monitoramento.items.find(a => a.id === aparicaoId);
    if (item && !item.bloqueado) {
      item.visualizado = 'SIM';
    }
  },
  [types.MARCAR_NAO_VISUALIZADA_APARICOES](state, aparicaoId) {
    let item = state.all.items.find(a => a.id === aparicaoId);
    if (item) item.visualizado = 'NAO';
    item = state.favoritos.items.find(a => a.id === aparicaoId);
    if (item) item.visualizado = 'NAO';
    item = state.monitoramento.items.find(a => a.id === aparicaoId);
    if (item) item.visualizado = 'NAO';
  },
  [types.RESETAR_APARICOES](state) {
    state.all.changed = true;
    state.monitoramento.changed = true;
    state.favoritos.changed = true;
  },
  [types.ATUALIZAR_PASTA_EM_NOTIFICACOES](state, { monitoramentoId, pasta }) {
    if (monitoramentoId === state.monitoramento.id) {
      if (typeof pasta !== 'undefined') {
        state.monitoramento.items.forEach((a) => {
          a.pasta = pasta;
        });
      } else {
        state.monitoramento.items.forEach((a) => {
          a.pasta = null;
        });
      }
    }
  },
  [types.MUDAR_PAGINA_DIARIO](state, diario) {
    state.aparicao.item.objeto = diario;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
